import fetch from './toFetch';
export default {
  // 用户信息
  getDownloadWays() {
    return fetch('/api/download/downloadway?site=wqn', {}, {
      type: 'GET'
    })
  }
}
